module.exports = __webpack_public_path__ + "static/media/indeed.92b26744.svg";